/* global window */

import React from 'react';
import { Provider } from 'react-redux';
import ConserveParameters from '@3plearning/routing-conserve-parameters';
import BasicApp from './basic-app';
import ErrorHandling from '../../helpers/error-handling';

// Components
import ErrorPage from '../components/error_page';
import MessageModal from '../components/message_modal';
import MathAZContainer from './math-az';


ConserveParameters(['username', 'password', 'authToken', 'env']);

export default class EntryApp extends BasicApp {
    render(store) {
        // NOTE: We have used a "render" attribute, rather than "component" to specify what
        //       should be rendered.  This allows us to pass options to the component. You
        //       can obviously simplify things if your components don't need any.
        if (store) {
            ErrorHandling.addResourceResponseErrorInterceptor(store.dispatch);
            
            return (
                <Provider store={store}>
                    <div>
                        <MathAZContainer />
                        <MessageModal />
                    </div>
                </Provider>
            );
        } else {
            return (
                <ErrorPage />
            );
        }
    }
}

window.EntryApp = EntryApp;
